<template>
  <div class="page wallet">
    <div class="title" style='position:fixed;top:0;z-index:999;width:7.5rem'>  
      <pageTitle title="附近酒店" v-if=" $route.query.sourceflag != 'app' "  />
    </div>
    <div id="mapA"></div>
  </div>
</template>
<style lang="less" scoped>
  #mapA{
    width: 7.5rem;height: 15.1rem;margin:0;font-family:"微软雅黑";
    top:0px;
    position:relative;
  }
</style>

<style>
    .BMap_bubble_title{
        overflow:scroll;
    }
</style>

<script>
import {BaiDuMap} from '../../components/BaiDuMap.js'
import Map from '../../components/map.js'
import api from '../../api'
import { mapGetters } from 'vuex'
import { mapMutations } from 'vuex'
import date from '../../utils/dateextend.js'
export default {
  data () {
    return {
      map:'',
      myIcon:'',
      change:'',
      map:'',
      geolocation:'',
      //当前坐标点
      maker:'',
      qps_i:'',
      lm_i:'',
      ht_i:'',
      df_i:'',
      bk_i:'',



        xx1:'121.48789949',
        xx2:'31.24916171',

        pointList : [],　//创建一个数组  

        infoList: [],　//创建一个数组  

        opts : {
            width : 250,     // 信息窗口宽度
            height: 110,     // 信息窗口高度
            enableMessage:true, //设置允许信息窗发送短息
        },

    }
  }
  ,
  mounted(){


    BaiDuMap().then( BMap => {
        // 创建Map实例
        this.initMap();
        // this.map.closeInfoWindow() ;
        // this.getPos();
    })
  }
  ,
  methods: {
    ...mapMutations([
      'setG_currentInfo','setG_searchParam'
    ]),
    loadData(city){
        var that = this;
        //获取数据
        var params = new this.URLSearchParam()
        params.append('cityName', city)
        params.append('checkInDate', this.g_searchParam.startDate)
        params.append('lng', this.xx1)
        params.append('lat', this.xx2)
        params.append('pageIndex', 1)
        params.append('pageSize', 800)
        this.$http.post(api.searchHotelNearBy(),params.toParam()).then((res) => {
            if(res.Result){
                var items = res.Data;
                //渲染数据
                for(var index in items){
                    var item = items[index]
                    that.addMarker(item)
                }
            }
        })
    },
    load(){
        return Map.load;
    },
    setMaker(maker){
        this.maker = maker
    },
    // getPos(){
    //     var map = this.map
    //     var setMaker = this.setMaker
    //     var oldMaker = this.maker
    //     this.geolocation.getCurrentPosition(function(r){
    //         if(this.getStatus() == BMAP_STATUS_SUCCESS){
    //             map.removeOverlay(oldMaker) 
    //             var maker = new BMap.Marker(r.point);
    //             setMaker(maker)
    //             map.addOverlay(maker);
    //             // map.centerAndZoom(r.point,15);
    //         }
    //         else {
    //         }        
    //     },{enableHighAccuracy: true})
    // },
 

    initMap(){
        //初始化地图

        this.map = new BMap.Map("mapA");
        var that = this;

        if (navigator.geolocation){

            navigator.geolocation.getCurrentPosition(
            function (position) {
                console.log(position)
                that.xx1 = position.coords.latitude;//获取纬度
                that.xx2 = position.coords.longitude;//获取经度

                var point = new BMap.Point(that.xx2, that.xx1);  // 创建点坐标  


                // 转换百度坐标点
                var pointArr = [];                pointArr.push(point);
                var convertor = new BMap.Convertor();
                convertor.translate(pointArr, 1, 5, that.translateCallback)



            }, function (error) {
                // 获取不到坐标点，给个上海静安寺意思一下。。
                var myCity = new BMap.LocalCity();
                var point = new BMap.Point(121.48789949, 31.24916171);  // 创建点坐标  

                // 转换百度坐标点
                var pointArr = [];                pointArr.push(point);
                var convertor = new BMap.Convertor();
                convertor.translate(pointArr, 1, 5, that.translateCallback)

            },{
                enableHighAcuracy : true,
                timeout :10000,
                maximumAge : 10000
            });
        }else{
            alert("不支持定位功能");
        }





        var size = new BMap.Size(37,39)
        this.geolocation = new BMap.Geolocation()
        this.ht_i = new BMap.Icon("../../../static/search/ht_i.png", size)
        this.qps_i = new BMap.Icon("../../../static/search/qps_i.png", size)
        this.lm_i = new BMap.Icon("../../../static/search/lm_i.png", size)
        this.df_i = new BMap.Icon("../../../static/search/df_i.png", size)
        this.bk_i = new BMap.Icon("../../../static/search/bk_i.png", size)
      


    },



    //坐标转换完之后的回调函数
    translateCallback (data){
        if(data.status === 0) {
            var marker = new BMap.Marker(data.points[0]);        // 创建标注    
            this.map.addOverlay(marker);                     // 将标注添加到地图中 
            // var label = new BMap.Label("转换后的百度坐标（正确）",{offset:new BMap.Size(20,-10)});
            // marker.setLabel(label); //添加百度label

            // this.map.enableScrollWheelZoom(true);     //开启鼠标滚轮缩放

            this.map.setCenter(data.points[0]);
            this.map.centerAndZoom(data.points[0],13);
            var that = this;
            var myCity = new BMap.LocalCity();
            myCity.get( function(result){
                that.loadData(result.name);
            })  ; 
        }
    },


    addMarker(item){
       var icon = this.getIcon(this,item.GRP)
      var pt = new BMap.Point(item.BmapPointx,item.BmapPointy)
	  var marker = new BMap.Marker(pt,{icon:icon})
	  this.map.addOverlay(marker)
      this.addInfo(marker,pt,item)
	},
    addInfo(marker,pt,item){
      var msg = '<a style="color:black;font-size:0.35rem;font-weight:600" href="#/search/homeList">' + item.HotelName + '</a>' + '<br/>' +
      '<div style="color:#999999;display:flex"><div style="width:70%;font-size:0.15rem;margin:auto 0">手机网站或客户端预订入住会员尊享最高3倍房费K币</div>' + 
      '<div style="color:#666666;width:30%;font-size:0.15rem;margin:15px 0;text-align:right"><span style="font-size:0.4rem;color:#FF8F3B;font-weight:600">' + item.LowestPrice + '</span>&nbsp;元起</div>' +
      '</div>'
      var infoWindow = new BMap.InfoWindow(msg, this.opts);  // 创建信息窗口对象
      var setInfo = this.setG_currentInfo 
      var model = this.g_currentInfo
      var getHotel = this.getHotel
	  marker.addEventListener("click", function(){    
        //修改缓存中的当前宾馆 
        var code = item.HotelCode
        model.HotelCode = code
        setInfo(model)
        //开启信息窗口  
	    this.map.openInfoWindow(infoWindow,pt);
        getHotel(code)
	  });
    },
    getHotel(code){
        var params = new this.URLSearchParam();
        params.append('hotelCode', code);
        params.append('startDate', this.g_searchParam.startDate);
        params.append('endDate', this.g_searchParam.endDate);
        this.$http.post(api.getHotelDetail(),params.toParam()).then((res) => {
            if(res.Result){
                this.setG_currentInfo(res.Data)
            }
        })
    },
    getIcon:(obj,input)=>{
        switch(input){
            case '00':
              return obj.ht_i
            case '50':
              return obj.qps_i
            case '30':
              return obj.lm_i
            case '40':
              return obj.df_i
            case '70':
              return obj.bk_i
        }
    },
 },
    computed: {
        ...mapGetters([
        'g_currentInfo','g_searchParam','g_city'
        ]),
    },
    created(){

    },
    activated(){
    //   //清空信息窗口
    //   if(this.map != '')
    //   {
    //     this.getPos();
    //   }
        // this.initMap();

    }
}
</script>


// WEBPACK FOOTER //
// nearbyHotels.vue?d3a1bc1c